// const server =
//   process.env.NODE_ENV === "development"
//     ? process.env.VUE_APP_SERVER
//     : location.origin;

const server = process.env.VUE_APP_SERVER;

export { server };
